import Alpine from 'alpinejs';

Alpine.data('tableAccordionItem', () => ({
    id: this.$root?.id,
    active: null,
    innerEl: null,
    buttonTopEl: null,
    buttonBottomEl: null,

    get expanded() {
        return this.active === this.$root.id;
    },
    set expanded(value) {
        this.active = value ? this.$root.id : null;
    },

    init() {
        this.innerEl = this.$root.querySelector('.table-accordion__item__inner');
        this.buttonTopEl = this.$root.querySelector('.container__scroll-buttons .container__scroll-button--top');
        this.buttonBottomEl = this.$root.querySelector('.container__scroll-buttons .container__scroll-button--bottom');

        if (window.innerWidth < 1024) {
            return;
        }

        [this.buttonTopEl, this.buttonBottomEl].forEach((element) => {
            element.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                const type = e.target.classList.contains('container__scroll-button--bottom') ? 'bottom' : 'top';

                this.innerEl.scrollTo({
                    left: 0,
                    top: this.innerEl.scrollTop + window.innerHeight * (type === 'top' ? -1 : 1),
                    behavior: 'smooth',
                });
            });
        });

        window.addEventListener('scroll', (e) => this.onScroll(e), true);
        window.addEventListener('resize', () => this.updateScrollButtonsAvailable(), true);
    },

    updateScrollButtonsAvailable() {
        let isScrollable = this.innerEl.scrollHeight > this.innerEl.getBoundingClientRect().height + 38;
        if (isScrollable) {
            this.buttonBottomEl.classList.add('container__scroll-button--is-available');
        } else {
            this.buttonBottomEl.classList.remove('container__scroll-button--is-available');
        }
    },

    onScroll(e) {
        let isTableAccordionInner = e.target.classList?.contains('table-accordion__item__inner');
        if (!isTableAccordionInner) return;

        //buttons
        let containerRect = this.innerEl.getBoundingClientRect();
        let isEdgeTop = this.innerEl.scrollTop <= 10;
        let isEdgeBottom = this.innerEl.scrollHeight - this.innerEl.scrollTop - containerRect.height <= 10;

        this.buttonTopEl.classList[isEdgeTop ? 'remove' : 'add']('container__scroll-button--is-available');
        this.buttonBottomEl.classList[isEdgeBottom ? 'remove' : 'add']('container__scroll-button--is-available');
    },
}));
